export default class CaptchaComponent {
  init(tries = 0) {
    if (typeof window.f12cf7captcha_cf7 !== 'undefined') {
      this.refreshCaptcha();
      this.initMultiStepForm();
      this.initFormErrors();
    } else if (tries < 5) {
      setTimeout(() => {
        this.init(tries + 1);
      }, 2000);
    }
  }

  initMultiStepForm() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const hasCurrentStepClass = window
          .jQuery(mutation.target)
          .hasClass('cf7mls_current_fs');

        if (hasCurrentStepClass) {
          this.refreshCaptcha();
        }
      });
    });

    document.querySelectorAll('.fieldset-cf7mls').forEach((button) => {
      observer.observe(button, {
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  }

  initFormErrors() {
    document.querySelectorAll('.wpcf7').forEach((wpcf7Elm) => {
      if (this.isHideLabelsForm(wpcf7Elm)) {
        wpcf7Elm.querySelectorAll('.f12-captcha').forEach((element) => {
          element.style.position = 'relative';
        });
      } else {
        wpcf7Elm
          .querySelectorAll('.f12-captcha input[type="text"]')
          .forEach((element) => {
            element.parentElement.style.position = 'relative';
          });
      }

      wpcf7Elm.addEventListener(
        'wpcf7invalid',
        (event) => {
          setTimeout(() => {
            this.handleFormErrors(wpcf7Elm, event);
          }, 200);
        },
        false
      );

      wpcf7Elm.addEventListener(
        'wpcf7submit',
        () => {
          this.clearFieldErrors(wpcf7Elm);
        },
        false
      );
    });
  }

  refreshCaptcha() {
    this.clearFieldErrors();
    window.f12cf7captcha_cf7.reloadAllCaptchas();
    window.f12cf7captcha_cf7.reloadTimer();
  }

  handleFormErrors(wpcf7Elm, event) {
    (event?.detail?.apiResponse?.invalid_fields || []).forEach((field) => {
      const input = wpcf7Elm.querySelector(
        `.f12-captcha input[name="${field.field}"]`
      );

      if (!input) {
        return; // Default behavior if not a f12 captcha field
      }

      const error = document.createElement('span');

      error.classList.add('wpcf7-not-valid-tip');
      error.innerText = field.message;

      input.parentNode.appendChild(error);
      input.classList.add('wpcf7-not-valid');
    });
  }

  clearFieldErrors(formElement = document) {
    formElement
      .querySelectorAll('.f12-captcha .wpcf7-not-valid-tip')
      .forEach((error) => {
        error.remove();
      });

    formElement
      .querySelectorAll('.f12-captcha .wpcf7-not-valid')
      .forEach((input) => {
        input.classList.remove('wpcf7-not-valid');
      });
  }

  isHideLabelsForm(element) {
    const all = document.querySelectorAll(
      '.contact-form-block--hide-labels .wpcf7'
    );

    for (const selectorElement of all) {
      if (selectorElement === element) {
        return true;
      }
    }

    return false;
  }
}
